export async function getMaterials() {
    const fullUrl = "/api/textile/materials";

    try {
        const response = await fetch(fullUrl, {
            method: "GET",
            credentials: "same-origin",
            mode: "cors",
            cache: "no-cache"
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        let materials = await response.json();

        materials = materials.map((material: any) => {
            if (material.id === "coton-rdpc" || material.id === "coton-rdp") {
                return { ...material, name: "Coton recyclé" };
            }
            return material;
        });

        return materials;
    } catch (error) {
        console.error('Error fetching data:', error);
        return [];
    }
}

export async function getCountries() {
    const fullUrl = "/api/textile/countries";

    try {
        const response = await fetch(fullUrl, {
            method: "GET",
            credentials: "same-origin",
            mode: "cors",
            cache: "no-cache"
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        let res = await response.json();
        return res;
    } catch (error) {
        console.error('Error fetching data:', error);
        return [];
    }
}

// async function getImpactSimulation(weight, materials, category, countryFabric, countryDyeing, countryMaking, fabricProcess) {
//     const fullUrl = "https://ecobalyse.beta.gouv.fr/api/textile/simulator?mass=" + weight + "&materials%5B%5D=" + materials +
//         "&product=" + category + "&countryFabric=" + countryFabric + "&countryDyeing=" + countryDyeing + "&countryMaking=" +
//         countryMaking + "&fabricProcess=" + fabricProcess;

//     let response = await fetch(new Request(fullUrl, {
//         method: "GET"
//     }));
//     if (!response.ok) {
//         throw new Error('Network Error');
//     }
//     if (response.status == 200) {
//         const similar_products = response.json();
//         return similar_products;
//     } else {
//         return null;
//     }
// }